import AttendanceSettingComponent from "../components/AttendanceSetting";
import useAttendance from "../hooks/useAttendance";

const AttendanceSetting = () => {
  const AttendanceProps = useAttendance();
  return <AttendanceSettingComponent {...AttendanceProps} />;
};

export default AttendanceSetting;
